var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logo)?_c('div',[(_vm.mapOnlyMode)?_c('v-img',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.displayMap),expression:"$store.state.displayMap"}],staticClass:"logo",staticStyle:{"position":"fixed"},style:(_vm._f("mq")(_vm.$mq,{
    mobile: 'top:2%;width:40%;margin:0 30%;',
    tablet: 'bottom:2%;width:20%;margin:0 98% 0 2%;',
    desktop: 'bottom:2%;width:10%;margin:0 98% 0 2%;'
  })),attrs:{"src":("./" + _vm.logo),"contain":""}}):_c('v-img',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.displayMap),expression:"$store.state.displayMap"}],staticClass:"logo",staticStyle:{"position":"fixed"},style:(_vm._f("mq")(_vm.$mq,{
    mobile: 'top:2%;width:40%;margin:0 30%;',
    tablet: 'bottom:2%;width:20%;margin:0 40%;',
    desktop: 'bottom:2%;width:10%;margin:0 45%;'
  })),attrs:{"src":("./" + _vm.logo),"contain":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }